import { Command, SearchData } from '../interfaces';

export enum SEARCH_SORT {
    RELEVANCE = 'RELEVANCE',
}

/**
 * Noop - return the data as is. This can be changed if a requirement comes in.
 * @param data a treatment
 * @returns SearchData[]
 */
export const searchSort = <T extends SearchData>(data: T[], keys: keyof typeof SEARCH_SORT) => {
    let result: SearchData[] = [];
    if (keys === SEARCH_SORT.RELEVANCE) {
        result = data;
    }
    return result;
};

export class SearchSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: SearchData[], keys: keyof typeof SEARCH_SORT) {
        return searchSort(data, SEARCH_SORT[keys]);
    }
}
